import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import PropTypes from "prop-types";
import React, { forwardRef } from "react";
import styled from "styled-components";
import { Icon } from "@xe/atom-icon";
import { lightenOrDarkenColor } from "@xe/util-color";
import { OldLink, SiteFooterLink, WhiteLink } from "./links-to-deprecate";
export { OldLink, SiteFooterLink, WhiteLink };
var BaseLink =
/*#__PURE__*/
styled("a").withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !["situated"].includes(prop);
  }
}).withConfig({
  displayName: "BaseLink"
})(["display:", ";", " color:", ";&:link,&:visited{color:", ";}&:active{color:", ";}text-decoration:", ";&:hover,&:active{text-decoration:", ";}"], function (_ref) {
  var situated = _ref.situated;
  return situated === "onItsOwn" ? "inline-flex" : "inline";
}, function (_ref2) {
  var situated = _ref2.situated;
  return situated === "onItsOwn" ? "align-items: center;" : "";
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.link.mainColor;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.link.mainColor;
}, function (_ref5) {
  var theme = _ref5.theme;
  return lightenOrDarkenColor(theme.link.mainColor, -20);
}, function (_ref6) {
  var situated = _ref6.situated;
  return situated === "inBlockOfText" ? "underline" : "none";
}, function (_ref7) {
  var situated = _ref7.situated;
  return situated === "inBlockOfText" ? "none" : "underline";
});
var Link =
/*#__PURE__*/
forwardRef(function Link(_ref8, ref) {
  var _ref8$situated = _ref8.situated,
      situated = _ref8$situated === void 0 ? "inBlockOfText" : _ref8$situated,
      children = _ref8.children,
      rest = _objectWithoutPropertiesLoose(_ref8, ["situated", "children"]);

  return (
    /*#__PURE__*/
    React.createElement(BaseLink, _extends({
      ref: ref,
      situated: situated
    }, rest), children, situated === "onItsOwn" ?
    /*#__PURE__*/
    React.createElement(Icon, {
      name: "chevron-right",
      color: "currentColor",
      width: "0.4375em",
      height: "0.75em",
      style: {
        marginLeft: "0.3125em"
      }
    }) : null)
  );
});
Link.propTypes = {
  situated: PropTypes.oneOf(["inBlockOfText", "inGroupOfLinks", "onItsOwn"]),
  children: PropTypes.node
};
export default Link;